import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardTypes, UserAppConfigurationRequest } from 'src/app/shared/models/api-request/me.models';
import { WithId } from 'src/app/shared/models/common/WithId';
import { MeRightsManagement } from 'src/app/shared/models/me/rights-management';
import { MeRightsMeeting } from 'src/app/shared/models/me/rights-meeting';
import { MeRightsMeetingState } from 'src/app/shared/models/me/rights-meeting-state';
import { MeRightsProfilPoint } from 'src/app/shared/models/me/rights-profil-point';
import { MeRightPoint } from 'src/app/shared/models/point/me-right-point.model';
import { PointSeance } from 'src/app/shared/models/point/point-seance';
import { IManagementRight } from 'src/app/shared/models/response/IMyManagementRight';
import { MeRight } from 'src/app/shared/models/right';

@Injectable({
  providedIn: 'root',
})
export class IDelibeMeService {
  public apiBaseUrl: string;

  constructor(public http: HttpClient) {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    this.apiBaseUrl = config.apiGatewayBaseUrl + '/api/v1';
  }

  getRightsManagement(): Observable<MeRightsManagement> {
    return this.http.get<MeRightsManagement>(`${this.apiBaseUrl}/Me/Rights/Management`);
  }

  getRightsPointsSeances(): Observable<PointSeance> {
    return this.http.get<PointSeance>(`${this.apiBaseUrl}/Me/Rights/pointsSeances`);
  }

  getRightsSeance(id: number): Observable<MeRightsMeeting> {
    return this.http.get<MeRightsMeeting>(`${this.apiBaseUrl}/Me/Rights/Seances/${id}`);
  }

  getRightsPoint(id: number): Observable<MeRightPoint> {
    return this.http.get<MeRightPoint>(`${this.apiBaseUrl}/Me/Rights/Points/${id}`);
  }

  getRightManagement(): Observable<IManagementRight> {
    return this.http.get<IManagementRight>(`${this.apiBaseUrl}/Me/Rights/Management`);
  }

  getSeancesStates(ids: any): Observable<MeRightsMeetingState[]> {
    let params = new HttpParams();
    if (ids.length > 0) {
      params = params.set('ids', ids);
    }
    return this.http.get<MeRightsMeetingState[]>(`${this.apiBaseUrl}/Me/Rights/Seances/States?${params}`);
  }

  getUserRights(): Observable<MeRight> {
    return this.http.get<MeRight>(`${this.apiBaseUrl}/Me/Rights`);
  }

  getPersonalParams(type: DashboardTypes, name?: string): Observable<WithId<UserAppConfigurationRequest>[]> {
    if (name) {
      return this.http.get<WithId<UserAppConfigurationRequest>[]>(
        `${this.apiBaseUrl}/Me/Configurations/PersonalParams?type=${type}&name=${name}`
      );
    } else {
      return this.http.get<WithId<UserAppConfigurationRequest>[]>(
        `${this.apiBaseUrl}/Me/Configurations/PersonalParams?type=${type}`
      );
    }
  }

  postPersonalParams(type: DashboardTypes, data: UserAppConfigurationRequest) {
    return this.http.post<WithId<UserAppConfigurationRequest>>(
      `${this.apiBaseUrl}/Me/Configurations/PersonalParams?type=${type}`,
      data
    );
  }

  putPersonalParams(type: DashboardTypes, personalParamsId: number, data: UserAppConfigurationRequest) {
    return this.http.put<WithId<UserAppConfigurationRequest>>(
      `${this.apiBaseUrl}/Me/Configurations/PersonalParams/${personalParamsId}?type=${type}`,
      data
    );
  }

  deletePersonalParams(type: DashboardTypes, id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiBaseUrl}/Me/Configurations/PersonalParams/${id}?type=${type}`);
  }

  getProfilRightsByPointID(pointId?: number): Observable<MeRightsProfilPoint> {
    if (pointId) {
      return this.http.get<MeRightsProfilPoint>(`${this.apiBaseUrl}/Me/ProfilRights/Points`, {
        params: { id: pointId },
      });
    } else {
      return this.http.get<MeRightsProfilPoint>(`${this.apiBaseUrl}/Me/ProfilRights/Points`);
    }
  }
}
